/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Value3
 */
export interface Value3 {
}

/**
 * Check if a given object implements the Value3 interface.
 */
export function instanceOfValue3(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Value3FromJSON(json: any): Value3 {
    return Value3FromJSONTyped(json, false);
}

export function Value3FromJSONTyped(json: any, ignoreDiscriminator: boolean): Value3 {
    return json;
}

export function Value3ToJSON(value?: Value3 | null): any {
    return value;
}

